export const academyAnnouncementBannerKeys = {
  root: ['academyAnnouncementBanners'],
  academyAnnouncementBanners: (academyId: string) => [...academyAnnouncementBannerKeys.root, academyId],
};

export const academyAnnouncementBannerKeysForLearner = {
  root: ['academyAnnouncementBannersForLearner'],
  academyAnnouncementBanners: (academyId: string) => [...academyAnnouncementBannerKeysForLearner.root, academyId],
};
